import { render, staticRenderFns } from "./approve-withdraw-modal.vue?vue&type=template&id=61b079ec&"
import script from "./approve-withdraw-modal.vue?vue&type=script&lang=js&"
export * from "./approve-withdraw-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports